import { Component, Input,ViewChild, OnDestroy } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { NbDialogRef } from '@nebular/theme';
import { PagesServices } from '../../pages.services';
import { UserManagementService } from '../../user-management/user-management.services';
declare var window: any; 
declare var $: any;

@Component({
    selector: "dialog-share-liveview-request",
    styleUrls: ["./dialog-share-liveview-request.scss"],
    templateUrl: "./dialog-share-liveview-request.html",
})
export class  DialogShareLiveviewRequestComponent implements OnDestroy {

    @ViewChild("form") form: any;
    @Input() device: any;
    modalCloseAction: any;
    submitted: boolean = false;

    loading: boolean = false;
    _userNameList:any;
    _selectUser: any = "";

    sendtype: string = 'user';
    isEmailEmpty: boolean = false;
    inputPhone: any = null;
    phoneNumberError: boolean = false;

    data: any = {
        txtPhone:'',
        txtEmail:'',
        txtDate: '',
        txtReqDate: '',
        txtPass: '',
        txtReqPass: '',
        countrycode: '',
        phoneNumber: ''
    };
    ngOnDestroy(): void {

        this.submitted = false;
    }

    constructor(protected ref: NbDialogRef<DialogShareLiveviewRequestComponent>,
        private _pagesServices : PagesServices) {

            this._userNameList =  this._pagesServices.deviceUsers.filter(q=>q.user_type == 'DISPATCH' && q.id != this._pagesServices.GetUserUUId());
            if(  this._userNameList.length > 0){
                this._selectUser = this._userNameList[0].device;
            }else{
                this.closeModal({ status: false });
            }

    }

    private closeModal(result: any) {
        this.ref.close(result);
    }

    dismiss() {
        this.closeModal({ status: false });
    }

    sendRequest(){
        this.submitted = true;
        if(this.data.txtPass == '' || this.data.txtPass == null){
            this.data.txtReqPass = false;
        }else{
            this.data.txtReqPass = true;
        } 

        this.data.txtDate = this.data.txtDate;
        if(this.data.txtDate == '' || this.data.txtDate == null){
            this.data.txtReqDate = false;
            this.data.txtDate = null;
        }else{
            this.data.txtReqDate = true;
        }
        
        if(this.sendtype == 'user'){
            this.closeModal({status: true,receiver:this._selectUser,sendertype:this.sendtype});
        }else if(this.sendtype == 'email'){
            let emailArray = [];
            Array.from($('.all-mail .email-ids .email-ids-name')).forEach(element => {
                emailArray.push((element as HTMLElement).innerHTML);
            });

            if(emailArray.length == 0){
                this.isEmailEmpty = true;
                return;
            }
            this.data.txtEmail = emailArray.join(',');
            if(!$('#txtPass')[0].validity.valid) { return;}
            this.closeModal({status: true,data:this.data,sendertype:this.sendtype});
        }else if(this.sendtype == 'phone'){
            const iti = window.intlTelInput.getInstance(this.inputPhone);
            let txtPhone = $('#txtPhone').val().replace(/\D/g,'');
            if(txtPhone.length < 9) {
                this.phoneNumberError = true;
                return;
            }else{
                this.data.countrycode = iti.getSelectedCountryData().iso2;
                this.data.phoneNumber = txtPhone;
                this.closeModal({status: true,data:this.data,sendertype:this.sendtype});
            }
        }
     
    }

    onChange(event: any) {
    this.resetDefault();
    if (event == 'email') {
        setTimeout(() => {
            $("#txtEmail").email_multiple({data: []});
        }, 10);
    }
    else if (event == 'phone') {
      setTimeout(() => {
         this.inputPhone = document.querySelector("#txtPhone");
         window.intlTelInput(this.inputPhone, {
          initialCountry: "us",
          separateDialCode: true,
          geoIpLookup: (success, failure) => {
            fetch("https://ipapi.co/json")
              .then((res) => res.json())
              .then((data) => success(data.country_code))
              .catch(() => failure());
          }
        });
      }, 10);
    }
  }

    filterFn(date): any {
        return date > (new Date()).setDate((new Date()).getDate());
    }

    checkEmailEmpty() {
        return this.submitted && this.isEmailEmpty && $('.all-mail .email-ids .email-ids-name').length == 0;
    }

    resetDefault(){
        this.data.txtPhone='';
        this.data.txtEmail='';
        this.data.txtDate='';
        this.data.txtReqDate='';
        this.data.txtPass='';
        this.data.txtReqPass='';
        this.isEmailEmpty = false;
        this.submitted = false;
    }

    
    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }
    
    phoneNumberOnly(event): boolean {
        this.phoneNumberError = false;
        return this.numberOnly(event);
    }
}
